import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("React error caught by ErrorBoundary:", error, info);
    // You can also send error to logging service here

    // Redirect to custom error page
    window.location.href = "/Server-Error";
  }

  render() {
    if (this.state.hasError) {
      // Return null or fallback UI if needed
      return <div>Something went wrong. Redirecting...</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
